import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLvtToken extends SnModel {
  @Expose()
  public accessToken: string;

  @Expose()
  public expiresIn: number;

  @Expose()
  public scope: string;

  @Expose()
  public tokenType: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
